import { render, staticRenderFns } from "./DeleteOpportunityStatusDialog.vue?vue&type=template&id=61e6e838"
import script from "./DeleteOpportunityStatusDialog.vue?vue&type=script&lang=js"
export * from "./DeleteOpportunityStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteOpportunityStatusDialog.vue?vue&type=style&index=0&id=61e6e838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports